export class SelfTestPelletizingPel {
    constructor({
          id= null, 
          selfTestCode = ``,
          sampleTime='',
          analysisTime = ``,
          moistureQh = ``,
          moistureSq = ``,
          compressionWet=``,
          compressionDry=``,
          pelSize=``,
          checkUser=``,
          status=``,
      } = {}) {
      this.id = id;
      this.selfTestCode = selfTestCode;
      this.sampleTime=sampleTime;
      this.analysisTime = analysisTime;
      this.moistureQh = moistureQh;
      this.moistureSq = moistureSq;
      this.compressionWet = compressionWet;
      this.compressionDry = compressionDry;
      this.pelSize=pelSize;
      this.checkUser=checkUser;
      this.status=status;
    }
  }
  export function gridFields() {
    return Object.freeze(
        [
    
       
        {
          key: 'selfTestCode',
          label: 'lbl.selfTestPelletizingPel.shiftPlanNum',
          sortable: true,
          form: {
            type: 'input'
          }
        },  
                
        {
          key: 'analysisTime',
          label: 'lbl.selfTestPelletizingPel.analysisTime',
          sortable: true,
          form: {
            type: 'dateTime'
          }
        },
        // {
        //   key: 'sampleTime',
        //   label: 'lbl.selfTestPelletizingPel.sampleTime',
        //   sortable: true,
        //   form: {
        //     type: 'input'
        //   }
        // },   
        {
            key: 'moistureQh',
            label: 'lbl.selfTestPelletizingPel.moistureQh',
            sortable: true,
            form: {
              type: 'input'
            }
          },
        {
          key: 'moistureSq',
          label: 'lbl.selfTestPelletizingPel.moistureSq',
          sortable: true,
          form: {
            type: 'input'
          }
        },
      
        {
          key: 'compressionDry',
          label: 'lbl.selfTestPelletizingPel.compressionDry',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'compressionWet',
          label: 'lbl.selfTestPelletizingPel.compressionWet',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'pelSize',
          label: 'lbl.selfTestPelletizingPel.pelSize',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'checkUser',
          label: 'lbl.selfTestPelletizingPel.checkUser',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'status',
          label: 'lbl.selfTestPelletizingPel.status',
          sortable: true,
          form: {
            type: 'select',
            options: [                
                { value: 'N', text:  '未检验' },
                { value: 'C', text:  '已检验' },                          
              ]            
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new SelfTestPelletizingPel()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.selfTestCodeFilter',
    'filter.analysisTimeDateFilter',
    'filter.residue1Filter',
    'filter.residue2Filter',
    'filter.residue3Filter',
    'filter.granularity1Filter',
    'filter.granularity2Filter',
    'filter.granularity3Filter',
    'filter.granularity4Filter',
    'filter.concentration',
    'filter.checkUser'
  ];
  export const filter = {
    'selfTestCodeFilter': "",
    'analysisTimeDateFilter': "",
    'residue1Filter': "",
    'residue2Filter': "",
    'residue3Filter':"",
    'granularity1Filter':"",
    'granularity2Filter':"",
    'granularity3Filter':"",
    'granularity4Filter':"",
    'concentration':"",
    'checkUser':"",
  };